export const PRODUCT_RECEIVE = 'PRODUCT_RECEIVE';
export const PRODUCT_FETCH_ERROR = 'PRODUCT_FETCH_ERROR';

export const PRODUCT_RATE_REQUEST = 'PRODUCT_RATE_REQUEST';
export const PRODUCT_REVIEW_FAILED = 'PRODUCT_REVIEW_FAILED';

export const PRODUCT_PRICE_CLICK = 'PRODUCT_PRICE_CLICK';

export const PRODUCT_RELATED_CLICK = 'PRODUCT_RELATED_CLICK';

export const PRODUCT_NAVIGATION = 'PRODUCT_NAVIGATION';

export const PRODUCT_PRICE_CLICK_BOUNCE = 'PRODUCT_PRICE_CLICK_BOUNCE';
export const PRODUCT_HEADER_CLICK = 'PRODUCT_HEADER_CLICK';

export const productReceive = response => {
  const product = response.data.product;

  return { type: PRODUCT_RECEIVE, product };
};

export const productFetchError = error => ({
  type: PRODUCT_FETCH_ERROR,
  error,
});

export const productRateRequest = (productId, rate) => ({
  type: PRODUCT_RATE_REQUEST,
  productId,
  rate,
});

export const productReviewFailed = () => ({
  type: PRODUCT_REVIEW_FAILED,
});

// NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
// reflected in react/middlewares/out.js pre click for tracking clicks before JS bundle
export const productPriceClick = (
  productId,
  price,
  featured,
  status,
  isAlternative
) => ({
  type: PRODUCT_PRICE_CLICK,
  productId,
  price,
  featured: featured ? 'Featured' : 'Not Featured',
  status,
  isAlternative,
});

export const productRelatedClick = (related, index) => ({
  type: PRODUCT_RELATED_CLICK,
  related,
  index,
});

export const productNavigation = (action, index) => ({
  type: PRODUCT_NAVIGATION,
  action,
  index,
});

export const productClickOutBounce = (productId, priceId) => ({
  type: PRODUCT_PRICE_CLICK_BOUNCE,
  productId,
  priceId,
});

export const headerClickEvent = event => ({
  type: PRODUCT_HEADER_CLICK,
  event,
});

export default {
  productRateRequest,
};
